import { Typography, useTheme } from '@mui/material';

interface FormHeaderProps {
  mode: 'create' | 'edit';
}

export function FormHeader({ mode }: FormHeaderProps) {
  const theme = useTheme();
  
  return (
    <Typography 
      variant="h4" 
      color={theme.palette.text.primary}
      sx={{ mb: 3 }}
    >
      {mode === 'create' ? 'Novo Pet' : 'Editar Pet'}
    </Typography>
  );
} 